module.exports = __webpack_public_path__ + "static/media/sign-in.08d32f0a.png";